import removeFromCalendarService from 'mini-calendar-event-services/lib/services/removeFromCalendarService';

export const removeItemServiceProvider = item => () => removeFromCalendarService(item);
